/*
 *
 * FeatureConfiguration actions
 *
 */

import {
  DEFAULT_ACTION,
  FETCH_SETTLEMENT_CONFIG,
  ENABLE_LOADER,
  DISABLE_LOADER,
  UPDATE_EASY_SPLIT_CONFIG,
  REQUEST_ON_DEMAND_ACTIVATION,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function fetchSettlementConfigAction(data) {
  return {
    type: FETCH_SETTLEMENT_CONFIG,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoader() {
  return {
    type: DISABLE_LOADER,
  };
}

export function updateEasySplitConfigAction(data) {
  return {
    type: UPDATE_EASY_SPLIT_CONFIG,
    data,
  };
}

export function requestOnDemandActivationAction(data) {
  return {
    type: REQUEST_ON_DEMAND_ACTIVATION,
    data,
  };
}
